<template>
  <div class="container-fluid page d-flex flex-column">
    
    <!-- Stats -->
    <div class="row">
      <div class="col-lg-3 mt-4">
        <stats-card title="Total Branches" :sub-title="totalBranches" icon="fa fa-store">
          <template v-slot:footer>
            <a class="router-link" href="#/lead-retailer/branch-management">View branches</a>
          </template>
        </stats-card>
      </div>

      <div class="col-lg-3 mt-4">
        <stats-card title="Charities Connected" :sub-title="totalConnectedCharities" icon="fa fa-ribbon" icon-classes="bg-info">
          <template v-slot:footer>
            <a class="router-link" href="#/lead-retailer/connected-charities">View charities</a>
          </template>
        </stats-card>
      </div>

      <div class="col-lg-3 mt-4">
        <stats-card title="Drops this month" :sub-title="dropsThisMonth.toString()" icon="fa fa-parachute-box" icon-classes="bg-success">
          <template v-slot:footer>
            <span :class="{
              'bad':changeIn(dropsThisMonth,dropsLastMonth).change < 0,
              'good': changeIn(dropsThisMonth,dropsLastMonth).change > 0}"
              >
              <i v-if="changeIn(dropsThisMonth,dropsLastMonth).change > 0" class="fa fa-arrow-up"></i>
              <i v-if="changeIn(dropsThisMonth,dropsLastMonth).change < 0" class="fa fa-arrow-down"></i>
              {{ changeIn(dropsThisMonth,dropsLastMonth).percent }}%</span>
              <span> since last month</span>
            
           </template>
        </stats-card>
      </div>

      <div class="col-lg-3 mt-4">
        <stats-card title="Issues this month" :sub-title="issuesThisMonth.toString()" icon="fa fa-exclamation" icon-classes="bg-warning">
          <template v-slot:footer>
             <span :class="{
              'good':changeIn(dropsThisMonth,dropsLastMonth).change < 0,
              'bad': changeIn(dropsThisMonth,dropsLastMonth).change > 0}"
              >
              <i v-if="changeIn(dropsThisMonth,dropsLastMonth).change > 0" class="fa fa-arrow-up"></i>
              <i v-if="changeIn(dropsThisMonth,dropsLastMonth).change < 0" class="fa fa-arrow-down"></i>
              {{ changeIn(issuesThisMonth,issuesLastMonth).percent }}%</span>
              <span> since last month</span>
          </template>
        </stats-card>
      </div>
    </div>
    
    <!-- Horizontal Rule -->
    <div class="row">
      <div class="col-12 my-4">
        <hr>
      </div>
    </div>

    <!-- Drop Status -->
    <div class="row flex-grow-1">
      <div class="col-12">
        <drop-status-card thisLocationType="retailerLead" :usePagination="true" :resultsPerPage="10" :showBranchFilter="true" :drops="todaysDrops"></drop-status-card>
      </div>
    </div>
    
  </div>
</template>
<script>
  // Imports
  import DropStatusCard from '@/components/Cards/DropStatusCard';
  import StatsCard from '@/components/Cards/StatsCard';
  import StatsService from '../../../services/StatsService';
  import DropsService from '../../../services/DropsService';
  import UserStore from '../../../services/UserStore';
  //
  export default {
    name: 'retailer-lead-dashboard',

    components: {
      DropStatusCard,
      StatsCard
    },

    data() {
      return {
        totalBranches: null,
        totalConnectedCharities: null,
        totalDrops: 0,
        totalIssues: 0,
        todaysDrops: [],
        dropsThisMonth: 0,
        dropsLastMonth: 0,
        issuesThisMonth: 0,
        issuesLastMonth: 0,
      };
    },
    
    created() {
      this.updateData();
    },

    methods:{
      updateData() {
        // Get the stats for this dashboard
        this.getStats();

        // No need to update availabilityPeriods
        this.updateTodaysDrops();
      },

      async getStats() {
        let result = await StatsService.getRetailerLeadDashboardStats()
        this.totalBranches = result.data.totalBranches.toString();
        this.totalConnectedCharities = result.data.relatedBranches.toString();
        this.totalDrops = result.data.totalDrops.toString();
        this.totalIssues = result.data.totalIssues.toString();
        this.dropsThisMonth = result.data.dropsThisMonth;
        this.dropsLastMonth = result.data.dropsLastMonth;
        this.issuesThisMonth = result.data.issuesThisMonth;
        this.issuesLastMonth = result.data.issuesLastMonth;
      },

      async updateTodaysDrops() {
        let result = await DropsService.getMine('upcoming');
        this.todaysDrops = result.data;
      },

      changeIn(value1,value2){

        let change = value1-value2;
        let percent = 0;
        if(change < 0 ){
          percent = change/value2 * -100;
        }else{
          percent = change/value2 * 100;
        }
        let data = {percent: percent.toFixed(1), change }
        return data;
      }
    }
  };
</script>
<style>
    .page {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 8rem);
  }

  .good{
    color:green;
  }

  .bad{
    color:red;
  }
</style>
